/*
 * Author: harper
 * File Created: Wednesday, 24-07-03 03:49 pm
 * Last Modified: Friday, 25-03-07 04:58 pm, by Ben Zhao
 */
import type { StyledComponent } from '@emotion/styled';

import { Box } from '@mui/material';
import { styled } from '@mui/material';
import type { BoxProps } from '@mui/material/Box';

export const Flex: StyledComponent<BoxProps> = styled(Box)(
  ({ alignItems }) => ({
    display: 'flex',
    ...(!alignItems && { alignItems: 'stretch' }),
  })
);
